import { render, staticRenderFns } from "./PropertyNavbar.vue?vue&type=template&id=01e9a25e&"
import script from "./PropertyNavbar.vue?vue&type=script&lang=js&"
export * from "./PropertyNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports